import { createRouter, createWebHistory } from "vue-router";
import { abortAll } from "@/api";
import { abortTrackedFetches } from "@/utils/fetchTracker";

const routes = [
  {
    path: "/",
    component: () => import("@/views/VerifyPage.vue"),
    meta: { title: "Verificación" },
  },
  {
    path: "/login",
    component: () => import("@/views/LoginPage.vue"),
    meta: { title: "Intranet - Login" },
  },
  {
    path: "/inicio",
    component: () => import("@/views/InicioPage.vue"),
    meta: { title: "Intranet - Inicio" },
  },

  {
    path: "/super_admin/comunicados",
    component: () => import("@/views/SuperAdminComunicadosPage.vue"),
    meta: { title: "Intranet - Super Admin Comunicados" },
  },
  {
    path: "/super_admin/webinar",
    component: () => import("@/views/SuperAdminWebinarPage.vue"),
    meta: { title: "Intranet - Super Admin Webinar" },
  },
  {
    path: "/super_admin/usuarios",
    component: () => import("@/views/SuperAdminUserIntranetPage.vue"),
    meta: { title: "Intranet - Super Admin User Intranet" },
  },
  {
    path: "/super_admin/proveedores",
    component: () =>
      import("@/views/admin/providers/SuperAdminProveedorPage.vue"),
    meta: { title: "Intranet - Super Admin Proveedor" },
  },
  {
    path: "/super_admin/directorio",
    component: () =>
      import("@/views/admin/directory/SuperAdminDirectorioPage.vue"),
    meta: { title: "Intranet - Super Admin Directorio" },
  },
  {
    path: "/super_admin/convenio",
    component: () =>
      import("@/views/admin/convenio/SuperAdminConvenioPage.vue"),
    meta: { title: "Intranet - Super Admin Convenio" },
  },
  {
    path: "/super_admin/promociones",
    component: () => import("@/views/SuperAdminFlyerPage.vue"),
    meta: { title: "Intranet - Super Admin Promociones" },
  },
  {
    path: "/super_admin/publicidad",
    component: () => import("@/views/SuperAdminPublicidadPage.vue"),
    meta: { title: "Intranet - Super Admin Publicidad" },
  },
  {
    path: "/super_admin/nosotros",
    component: () => import("@/views/SuperAdminNosotrosPage.vue"),
    meta: { title: "Intranet - Super Admin Nosotros" },
  },
  {
    path: "/super_admin/consejo",
    component: () => import("@/views/SuperAdminConsejoPage.vue"),
    meta: { title: "Intranet - Super Admin Consejo" },
  },
  {
    path: "/super_admin/actividades",
    component: () => import("@/views/SuperAdminActividadesPage.vue"),
    meta: { title: "Intranet - Super Admin Actividades" },
  },
  {
    path: "/super_admin/instalaciones",
    component: () => import("@/views/SuperAdminInstalacionesPage.vue"),
    meta: { title: "Intranet - Super Admin Instalaciones" },
  },
  {
    path: "/super_admin/herramientas",
    component: () => import("@/views/SuperAdminHerramientasPage.vue"),
    meta: { title: "Intranet - Super Admin Herramientas" },
  },
  {
    path: "/super_admin/formatos",
    component: () => import("@/views/SuperAdminFormatosPage.vue"),
    meta: { title: "Intranet - Super Admin Formatos" },
  },
  {
    path: "/super_admin/empresas",
    component: () => import("@/views/SuperAdminEmpresasPage.vue"),
    meta: { title: "Intranet - Super Admin Empresas" },
  },
  {
    path: "/chat",
    component: () => import("@/views/ChatPage.vue"),
    meta: { title: "Intranet - Chat" },
  },
  {
    path: "/proveedores",
    component: () => import("@/views/providers/ProveedoresPage.vue"),
    meta: { title: "Intranet - Proveedores" },
  },
  {
    path: "/directorio",
    component: () => import("@/views/directory/DirectorioPage.vue"),
    meta: { title: "Intranet - Directorio" },
  },
  {
    path: "/convenio",
    component: () => import("@/views/convenio/ConvenioPage.vue"),
    meta: { title: "Intranet - Convenio" },
  },
  {
    path: "/promociones",
    component: () => import("@/views/flyers/PromotionalPage.vue"),
    meta: { title: "Intranet - Promociones" },
  },
  {
    path: "/herramientas",
    component: () => import("@/views/tools/ToolsPage.vue"),
    meta: { title: "Intranet - Herramientas" },
  },
  {
    path: "/nosotros",
    component: () => import("@/views/nosotros/NosotrosPage.vue"),
    meta: { title: "Intranet - Nosotros" },
  },
  {
    path: "/consejo",
    component: () => import("@/views/consejo/ConsejoPage.vue"),
    meta: { title: "Intranet - Consejo" },
  },
  {
    path: "/capacitaciones",
    component: () => import("@/views/CapacitacionesPage.vue"),
    meta: { title: "Intranet - Capacitaciones" },
  },
  {
    path: "/actividades",
    component: () => import("@/views/activities/ActividadesPage.vue"),
    meta: { title: "Intranet - Actividades" },
  },
  {
    path: "/instalaciones",
    component: () => import("@/views/installations/InstalacionesPage.vue"),
    meta: { title: "Intranet - Instalaciones" },
  },
  {
    path: "/me",
    component: () => import("@/views/MePage.vue"),
    meta: { title: "Intranet - Me" },
  },
  {
    path: "/capacitaciones/sala",
    component: () => import("@/views/CapacitacionesSalaPage.vue"),
    meta: { title: "Intranet - Capacitaciones Sala" },
  },

  {
    path: "/foros",
    name: "foros",
    component: () => import("@/views/forum/ForumsPage.vue"),
    meta: { title: "Intranet - Foros" },
  },
  {
    path: "/suscripciones",
    name: "suscripciones",
    component: () => import("@/views/forum/SuscriptionList.vue"),
    meta: { title: "Intranet - Suscripciones" },
  },
  {
    path: "/destacadas",
    name: "destacadas",
    component: () => import("@/views/forum/FeaturedAnswerList.vue"),
    meta: { title: "Intranet - Destacadas" },
  },
  {
    path: "/admin-foro",
    name: "admin-view",
    component: () => import("@/views/AdminView.vue"),
    meta: { title: "Intranet - Admin Foro" },
  },

  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/NotFoundPage.vue"),
    meta: { title: "Página no encontrada" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  const defaultTitle = "Intranet";
  document.title = to.meta.title || defaultTitle;
});

// Cancel outstanding API requests when navigating between routes
router.beforeEach((to, from, next) => {
  try {
    abortAll();
    abortTrackedFetches();
  } catch (e) {
    /* ignore */
  }
  next();
});

export default router;
// import { createRouter, createWebHashHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
// import LoginView from '../views/LoginView.vue'

// const routes = [
//   {
//     path: '/',
//     name: 'home',
//     component: HomeView
//   },
//   {
//     path: '/login',
//     name: 'login',
//     component: LoginView
//   },
//   {
//     path: '/about',
//     name: 'about',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
//   }
// ]

// const router = createRouter({
//   history: createWebHashHistory(),
//   routes
// })

// export default router
